import React, { useEffect } from "react";
import { useSelector } from "react-redux";
// Material
import { Alert, AlertTitle } from "@material-ui/lab";
// import Button from "@material-ui/core/Button";
// Custom Hooks
import useDynamicHotelData from "../../CustomHooks/useDynamicHotelData";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorIcon from "@material-ui/icons/Error";
// Utils
import { dispatchResetErrorMessage } from "../../utils/Shared";
// Styles
import useStyles from "./style.js";
import { Button } from "@material-ui/core";

function ResturantMessageBar({ onActionClick = () => {} }) {
  const classes = useStyles();
  // const [open, setOpen] = useState(false);
  // const { hotel } = useSelector((state) => state.hotel);
  const error = useSelector((state) => state.error);

  const { hotelStatus, hotelOrderStatus } = useDynamicHotelData();

  // useEffect(() => {
  //   if (!hotelStatus.active) {
  //     setOpen(true);
  //   } else {
  //     setOpen(false);
  //   }
  // }, [hotelStatus]);

  // useEffect(() => {
  //   if (!error?.noAutoClose) {
  //     const timer = setTimeout(() => {
  //       dispatchResetErrorMessage();
  //     }, 5000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [error?.noAutoClose]);

  const openHoursfunc = () => {
    dispatchResetErrorMessage();
    onActionClick();
  };

  return (
    <>
      {error.showAs === "Warning" && error.show && (
        // {!error.show && (
        <Alert
          variant="filled"
          // severity={error.title === "Warning" ? "Warning" : "error"}
          severity={"Warning"}
          // classes={{ root: classes.root, message: classes.messageContainer }}
          // classes={{
          //   root: `${classes.root} ${
          //     error.title === "Warning"
          //       ? classes.backgroundWarning
          //       : classes.backgroundError
          //   } ${classes.noIcon}`, // 👈 add noIcon here
          //   message: classes.messageContainer,
          // }}
          classes={{
            root: `${error?.specialAlert ? classes.splMainRoot : classes.root} ${error?.specialAlert ? classes.splBackgroundWarning : classes.backgroundWarning} ${classes.noIcon}`, // 👈 add noIcon here
            message: classes.messageContainer,
          }}
          // onClose={() => {
          //   // setOpen(false);
          //   dispatchResetErrorMessage();
          // }}
        >
          <div
            className={
              error.specialAlert ? classes.splAlertDiv : classes.alertDiv
              // error.title === "Warning" ? classes.alertDiv : classes.alertErrDiv
            }
          >
            {error.title === "Warning" && !error.specialAlert ? (
              <span className={classes.iconWithTitle}>
                <WarningIcon className={classes.icon} />
                <span className={classes.iconText}>{error.title}</span>
              </span>
            ) : error.specialAlert ? (
              <span className={classes.iconwithoutTitle}>
                  <span className={classes.iconSplText}>Store Closed</span>
              </span>
            ) : (
              <span className={classes.iconWithTitle}>
                <ErrorIcon className={classes.icon} />
                <span className={classes.iconText}>{error.title}</span>
              </span>
            )}
            {/* <AlertTitle>{error.title}</AlertTitle> */}
            {/* {error.message} */}
          </div>
          {/* <div className={classes.alertMsgDiv}>{error.message}</div> */}
          <div
            className={error.specialAlert ? classes.splAlertMsgDiv : classes.alertMsgDiv}
            dangerouslySetInnerHTML={{ __html: error.message }}
          />
          <div className={classes.actionButtonContainer}>
            <Button
              variant="contained"
              color="primary"
              className={!error.specialAlert? classes.okButton :classes.splOkbutton}
              onClick={dispatchResetErrorMessage}
            >
              OK
            </Button>

            {/* {hotelOrderStatus && (
              <Button
                variant="contained"
                color="primary"
                className={
                  error?.title === "Warning"
                    ? classes.actionButton
                    : classes.errorActionButton
                }
                // onClick={onActionClick}
                onClick={openHoursfunc}
              >
                See Opening Hours
              </Button>
            )} */}
          </div>
        </Alert>
      )}
    </>
  );
}
export default ResturantMessageBar;
